const CHART_COLORS = {
  red: ["#FECACA", "#FCA5A5", "#F87171", "#EF4444", "#DC2626"],
  amber: ["#FDE68A", "#FCD34D", "#FBBF24", "#F59E0B", "#D97706"],
  green: ["#BBF7D0", "#86EFAC", "#4ADE80", "#22C55E", "#16A34A"],
  purple: ["#E9D5FF", "#D8B4FE", "#C084FC", "#A855F7", "#9333EA"],
  blue: ["#BFDBFE", "#93C5FD", "#60A5FA", "#3B82F6", "#2563EB"],
};

/* ─── Tiny Bar Sparkline ─── */
const Sparkline = ({ color }) => (
  <div className="flex items-end gap-0.5 h-10">
    {(CHART_COLORS[color] || CHART_COLORS.red).map((c, i) => (
      <div
        key={i}
        style={{
          backgroundColor: c,
          height: `${(i + 1) * 20}%`,
          width: "6px",
          borderRadius: "2px",
        }}
      />
    ))}
  </div>
);

export default function EmergencyStats({ statCards }) {
  if (!statCards || statCards.length === 0) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
      {statCards.map((card) => (
        <div
          key={card.label}
          className="bg-white border rounded-xl shadow-sm p-4 md:flex items-center justify-between"
        >
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: card.iconBg }}
              >
                {card.icon}
              </div>
              <p className="text-xs font-sans text-gray-500">{card.label}</p>
            </div>
            <div className="flex items-baseline gap-2">
              <p className="text-2xl font-bold text-[#333333] font-sans">
                {card.value}
              </p>
              <span
                className={`text-xs font-sans ${
                  card.up ? "text-green-500" : "text-gray-400"
                }`}
              >
                {card.up ? "↑" : ""} {card.pct}
              </span>
            </div>
          </div>
          <Sparkline color={card.chart} />
        </div>
      ))}
    </div>
  );
}
